import { BontonPanel } from './../../../../environments/bonton-panel';
import { DateTime } from 'luxon';
import { Linq } from 'app/utils/linq';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AsyncPipe, NgClass, DatePipe } from '@angular/common';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { flightClass, flightFareType, themes } from 'app/utils/const';
import {
    Observable,
    ReplaySubject,
    Subject,
    Subscription,
    debounceTime,
    distinctUntilChanged,
    filter,
    startWith,
    switchMap,
    takeUntil,
} from 'rxjs';
import { FlightsService } from './../../../services/flights.service';
import { CacheService } from 'app/services/cache.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TravellersClassComponent } from '../travellers-class/travellers-class.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ToasterService } from 'app/services/toaster.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DateAdapter, MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import { LuxonDateAdapterService } from 'app/services/LuxonDateAdapter.service';
import { CommonUtils, MY_DATE_FORMATS } from 'app/utils/commonutils';
import { SettingsService } from 'app/services/settings.service';
import { B2cSignInComponent } from 'app/modules/auth/b2c-sign-in/b2c-sign-in.component';
import { PrimeNgImportsModule } from 'app/_model/imports_primeng/imports';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { VideoHelpService } from 'app/services/VideoHelp.service';
import { APICall } from 'app/utils/Helper/APICall';
import { API } from 'app/utils/Helper/api-endpoints';
import { CacheLabel } from 'app/utils/Helper/cache.service';

@Component({
    selector: 'app-flights-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        DatePipe,
        AsyncPipe,
        FormsModule,
        ReactiveFormsModule,
        MatRadioModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatDialogModule,
        NgxMatSelectSearchModule,
        SlickCarouselModule,
        MatRippleModule,
        PrimeNgImportsModule,
        MatButtonToggleModule
    ],
    providers: [
        { provide: DateAdapter, useClass: LuxonDateAdapterService },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
})
export class MainComponent implements OnInit {
    @ViewChild('fromCitySelect') fromCitySelect: MatSelect;
    @ViewChild('toCitySelect') toCitySelect: MatSelect;
    @ViewChildren('fromMultiCitySelect') fromMultiCitySelect: QueryList<MatSelect>;
    @ViewChildren('toMultiCitySelect') toMultiCitySelect: QueryList<MatSelect>;

    fareMap: { [key: string]: number } = {}; // Store date-wise fares
    selectedFromCity: string = '';
    selectedToCity: string = '';
    bontonPanel = BontonPanel;
    themes = themes;
    subscription: Subscription;
    wlSettingsDetails: any = {};
    flightData: any = {};
    selectedField: string = '';
    selectedFieldIndex: number;
    returnFareMap: any = {}

    flightType = [
        { id: 'ow', name: 'One Way' },
        { id: 'rt', name: 'Round Trip' },
        { id: 'mc', name: 'Multi City' },
        { id: 'gi', name: 'Group Inquiry' },
    ];

    fareType: any[] = [];

    slideConfigFlight = {
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000
    };

    slideConfig = {
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 5,
        dots: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        variableWidth: true,
        centerMode: false,
        margin: 10,
    };

    slideConfig1 = {
        arrows: false,
        slidesToShow: 2, slidesToScroll: 1, dots: true, infinite: false, autoplay: false,
        autoplaySpeed: 3000,
    };

    formGroup: FormGroup;
    fromCityList = new ReplaySubject<any[]>();
    toCityList = new ReplaySubject<any[]>();
    pax: number = 1;
    settings: any = {};
    minDate = new Date();
    formDataList: any[] = [];
    allCity: any[];
    recentFlightSearchList: any[] = [];
    popularFlights: any[] = [];
    tab = 0;
    PopularRecordsList: any;
    _unsubscribeAll: Subject<any> = new Subject();
    isOpenTravellersClass: boolean;
    isFirstService: boolean = CommonUtils.getB2COrderByUrl() === 'flights';

    /**
     * Constructor - Initializes the MainComponent with required services and sets up initial configuration
     * @param router - Angular Router service for navigation
     * @param flightsService - Service for flight-related operations
     * @param builder - FormBuilder service for creating reactive forms
     * @param route - ActivatedRoute service for accessing route parameters
     * @param matDialog - MatDialog service for opening dialog components
     * @param cacheService - Service for caching data
     * @param alertService - Service for displaying toast notifications
     * @param settingService - Service for accessing application settings
     */
    constructor(
        private router: Router,
        private flightsService: FlightsService,
        private builder: FormBuilder,
        private route: ActivatedRoute,
        private matDialog: MatDialog,
        private cacheService: CacheService,
        private alertService: ToasterService,
        private settingService: SettingsService,
        private videoHelpService: VideoHelpService
        // private commanService: CommanService
    ) {
        if (this.bontonPanel.isB2C()) {
            this.flightType = this.flightType.filter(f => f.id !== 'gi');
        }
        this.settingService.settings.pipe(takeUntil(this._unsubscribeAll)).subscribe(settings => {
            this.settings = settings;
            this.wlSettingsDetails = settings;
            this.flightData = this.wlSettingsDetails?.service_search_sections?.find(x => x.section_for.toLowerCase() == "flight");
            this.settingService.updateSeoPageMeta('flights'); // Seo Page Meta Details Updates

            // B2C if false → remove Airline Block
            if (this.bontonPanel.isB2C()) {
                const index = this.flightType.findIndex(f => f.id === 'ab');
                if (this.flightData.enable_air_block_section) {
                    // true → ensure Airline Block is added
                    if (index === -1) {
                        this.flightType.push({ id: 'ab', name: 'Airline Block' });
                    }
                } else {
                    // false → ensure Airline Block is removed
                    if (index !== -1) {
                        this.flightType.splice(index, 1);
                    }
                }
            }

        });

        if (this.bontonPanel.isB2B()) {
            this.flightType.push({ id: 'ab', name: 'Airline Block' });
        }
    }

    /**
     * Angular lifecycle hook that initializes the component after Angular has initialized all data-bound properties
     * Sets up form controls, subscriptions, and initializes data for the flight search functionality
     */
    ngOnInit(): void {

        this.route.paramMap.subscribe((param) => {
            const action = param.get('action');
            if (action == 'reset-password') {
                this.route.queryParamMap.subscribe((qparam) => {
                    const code = qparam.get('code');
                    if (code) {
                        this.matDialog.open(B2cSignInComponent, {
                            data: { isReset: true, code },
                            disableClose: true,
                            panelClass: [CommonUtils.isMobile() || CommonUtils.isTablet() ? 'full-screen-model' : 'full-width-dialog', 'custom-class'],
                            backdropClass: 'dark-background'
                        });
                        this.router.navigate(['/flights']);
                    }
                });
            }
        });

        this.route.queryParamMap.subscribe((param) => {
            const fbclid = param.get('fbclid');

            if (fbclid && fbclid.trim() != '')
                this.router.navigate(['/flights']);
        });

        this.formGroup = this.builder.group({
            type: ['ow'],
            fromCity: [''],
            fromCityfilter: [''],
            toCity: [''],
            toCityfilter: [''],
            departureDate: [new Date()],
            returnDate: [null],
            cabinClass: [flightClass.economy],
            fareType: ['Regular'],
            adult: [1],
            child: [0],
            infant: [0],
            device: ['WEB'],
            multiCityObjects: [this.formDataList],
        });

        if (this.bontonPanel.isB2B()) {
            this.getRecentFlightSearch();
            this.getPopularRecords();
        }
        this.getFareTypeList();

        const oldJSON = JSON.parse(
            localStorage.getItem('flight-filters') || '{}'
        );
        if (oldJSON.fromCity) {
            // Convert departureDate from 'yyyy-MM-dd' to a Date object
            const departureDate = oldJSON.departureDate
                ? new Date(oldJSON.departureDate)
                : new Date(); // Fallback to today if invalid

            // Convert returnDate from 'yyyy-MM-dd' to a Date object, or null if not present
            const returnDate = oldJSON.returnDate
                ? new Date(oldJSON.returnDate)
                : null; // Use null if no return date

            // Ensure the date is not in the past
            if (departureDate < new Date()) {
                oldJSON.departureDate = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd');
            }

            // Patch the form with the converted date
            this.formGroup.patchValue({
                ...oldJSON,
                departureDate: new Date(oldJSON.departureDate), // Convert to Date object
                returnDate: returnDate && !isNaN(returnDate.getTime()) ? returnDate : null, // Convert to Date object
            });
        }

        const departureDate = new Date(oldJSON.departureDate || new Date());
        // const returnDate = new Date(oldJSON.returnDate) || '';

        this.formGroup.patchValue({
            departureDate: departureDate,
        });

        const cityFromId = oldJSON.fromCity;
        const cityToId = oldJSON.toCity;
        this.flightsService
            .getAirportMstCombo('', cityFromId, cityToId,(this.formGroup.get('type').value=='ab'?true:false))
            .subscribe({
                next: (res) => {
                    this.allCity = res;
                    this.fromCityList.next(res);
                    this.toCityList.next(res);
                    this.formGroup.get('fromCity').patchValue(res[0]);
                    this.formGroup.get('toCity').patchValue(res[1]);
                    this.selectedFromCity = this.formGroup.value.fromCity.airport_code
                    this.selectedToCity = this.formGroup.value.toCity.airport_code
                    this.fetchDateWiseFares();

                    if (this.formDataList.length < 2) {
                        this.formDataList.forEach((x: MulticityDTO) => {
                            x.fromListData = res;
                            x.toListData = res;
                            x.allListData = res;
                        });
                        this.addCity(0);
                    }
                }, error: (err) => {
                    this.alertService.showToast('error', err);
                }
            });
        this.formGroup
            .get('fromCityfilter')
            .valueChanges.pipe(
                filter((x) => !!x),
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                switchMap((value: string) => {
                    return value
                        ? this.flightsService.getAirportMstCombo(value,'','',(this.formGroup.get('type').value=='ab'?true:false))
                        : new Observable<any[]>();
                })
            )
            .subscribe({
                next: (res) => (res ? this.fromCityList.next(res) : null),
            });

        this.formGroup
            .get('toCityfilter')
            .valueChanges.pipe(
                filter((x) => !!x),
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                switchMap((value: string) => {
                    return value
                        ? this.flightsService.getAirportMstCombo(value,'','',(this.formGroup.get('type').value=='ab'?true:false))
                        : new Observable<any[]>();
                })
            )
            .subscribe({
                next: (res) => (res ? this.toCityList.next(res) : null),
            });

        this.formGroup.get('type').valueChanges.subscribe((value) => {
            if (value === 'rt')
                this.formGroup
                    .get('returnDate')
                    .patchValue(this.formGroup.get('departureDate').value);
            else this.formGroup.get('returnDate').patchValue(null);
        });

        this.formGroup.get('departureDate').valueChanges.subscribe((v) => {
            const changedDate = DateTime.fromJSDate(new Date(v)).toFormat('yyyy-MM-dd');
            const returnDateValue = new Date(this.formGroup.get('returnDate').value);
            const toDate = DateTime.fromJSDate(returnDateValue).toFormat('yyyy-MM-dd');

            if (toDate < changedDate && this.formGroup.get('type').value == 'rt') {
                this.formGroup.get('returnDate').patchValue(v);
            }
        });

        let multicityForm: MulticityDTO[] = [];
        const multicity = new MulticityDTO();
        multicityForm.push(multicity);

        this.formDataList = [...multicityForm];

        if (oldJSON.multiCityObjects?.length > 1) {
            this.formDataList = [...oldJSON.multiCityObjects];
            this.formDataList.forEach((x) => {
                if (new Date(x.departureDate) < new Date())
                    x.departureDate = DateTime.fromJSDate(new Date()).toFormat(
                        'yyyy-MM-dd'
                    );
            });
            this.formGroup
                .get('multiCityObjects')
                .patchValue(this.formDataList);
        } else {
            this.formDataList.forEach((x) => {
                x.fromCity = x.fromListData[0];
                x.toCity = x.toListData[0];
                x.departureDate = DateTime.fromJSDate(new Date()).toFormat(
                    'yyyy-MM-dd'
                );
            });
            this.formGroup
                .get('multiCityObjects')
                .patchValue(this.formDataList);
        }

        if (this.formGroup.get('type').value != 'mc') {
            this.formGroup.get('multiCityObjects').patchValue([]);
        }
    }

    getFareTypeList(): void {
        this.flightsService.getFareTypeList().subscribe({
            next: (res) => {
                if (res) {
                    this.fareType = res;
                    localStorage.setItem('flightFareTypeList', JSON.stringify(res));
                } else {
                    this.fareType = [];
                }
            },
        });
    }

    // Convert PrimeNG date object to "YYYY-MM-DD" format
    /**
     * Converts PrimeNG date object to "YYYY-MM-DD" format
     * @param date - PrimeNG date object containing year, month, and day properties
     * @returns Formatted date string in "YYYY-MM-DD" format
     */
    getFormattedDate(date: any): string {
        const year = date.year;
        const month = (date.month + 1).toString().padStart(2, '0'); // Ensure 2-digit month
        const day = date.day.toString().padStart(2, '0'); // Ensure 2-digit day
        return `${year}-${month}-${day}`;
    }

    // Function to fetch fares when "From" and "To" cities are selected
    /**
     * Fetches date-wise fares for the selected from and to cities
     * Makes an API call to get fare data and stores it in the fareMap property
     */
    fetchDateWiseFares() {
        if (this.selectedFromCity && this.selectedToCity) {
            this.flightsService.getDateWiseFares(this.selectedFromCity, this.selectedToCity, 'ow').subscribe({
                next: (res) => {
                    if (res) {
                        this.fareMap = res.data.reduce((acc: any, item: any) => {
                            acc[item.date] = { price: item.price, is_orange: item.is_orange };
                            return acc;
                        }, {});
                    } else {
                        this.fareMap = {}
                    }
                }, error: (err) => {
                    this.fareMap = {}
                }
            });
        }
    }

    // Fetch fares for return (e.g., DEL to BOM)
    /**
     * Fetches return date fares for round trip flights
     * Makes an API call to get fare data for the return journey and stores it in the returnFareMap property
     */
    fetchReturnDateFares(): void {
        if (this.formGroup.get('type').value === 'rt' && this.selectedFromCity && this.selectedToCity) {
            this.flightsService.getDateWiseFares(this.selectedToCity, this.selectedFromCity, 'rt').subscribe({
                next: (res) => {
                    if (res) {
                        this.returnFareMap = res.data.reduce((acc: any, item: any) => {
                            acc[item.date] = { price: item.price, is_orange: item.is_orange };
                            return acc;
                        }, {});
                    } else {
                        this.returnFareMap = {};
                    }
                },
                error: (err) => (this.returnFareMap = {}),
            });
        }
    }

    // Called when "From" city is selected
    /**
     * Handles the change event when a "From" city is selected
     * Updates the selectedFromCity property and triggers fare fetching
     * @param selectedCity - The selected city object containing airport_code
     */
    onFromCitySelectionChange(selectedCity: any) {
        this.selectedFromCity = selectedCity.airport_code; // Use city ID or code
        this.fetchDateWiseFares();
    }

    // Called when "To" city is selected
    /**
     * Handles the change event when a "To" city is selected
     * Updates the selectedToCity property and triggers fare fetching
     * @param selectedCity - The selected city object containing airport_code
     */
    onToCitySelectionChange(selectedCity: any) {
        this.selectedToCity = selectedCity.airport_code; // Use city ID or code
        this.fetchDateWiseFares();
    }

    // Function to format date for binding prices
    /**
     * Formats a date object for binding prices in the calendar
     * @param date - Date object containing year, month, and day properties
     * @returns Formatted date string in "YYYY-MM-DD" format
     */
    getFormattedDateNew(date: any): string {
        return `${date.year}-${String(date.month + 1).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    }

    /**
     * Opens a URL in a new browser window/tab
     * @param str - The URL to open in the new window
     */
    openNewWindow(str: string) {
        window.open(str, '_blank')
    }

    /**
     * Handles tab change events in the component
     * @param tab - The index of the selected tab
     */
    tabChanged(tabIndex: number) {
        this.tab = tabIndex;
        this.popularFlights = tabIndex === 0 ? this.PopularRecordsList?.finalDom ?? [] : this.PopularRecordsList?.finalInt ?? [];
    }

    /**
     * Clears the departure date field in the form
     */
    cancelDepartureDate() {
        this.formGroup.get('departureDate').setValue(null);
    }

    /**
     * Clears the return date field and switches flight type to One Way if currently Round Trip
     */
    cancelReturnDate() {
        this.formGroup.get('returnDate').setValue("null");
        if (this.formGroup.get('type').value == 'rt')
            this.formGroup.get('type').setValue('ow');
    }

    /**
     * Fetches recent flight search history from the service
     * Updates the recentFlightSearchList with the retrieved data
     */
    getRecentFlightSearch() {
        this.flightsService.flightRecentSearch().subscribe((res: any) => {
            this.recentFlightSearchList = res;
        });
    }

    /**
     * Fetches popular flight records from the service
     * Updates the PopularRecordsList with the retrieved data
     */
    getPopularRecords() {
        APICall.ApiCall({
            method: 'POST',
            endpoint: API.getPopularRecords,
            cacheLabel: CacheLabel.PopularFlightRecords,
            onSuccess: (res: any) => {
                this.PopularRecordsList = res;
                this.popularFlights = this.tab === 0 ? this.PopularRecordsList?.finalDom ?? [] : this.PopularRecordsList?.finalInt ?? [];
            },
        });

        // this.flightsService.getPopularRecords().subscribe((res: any) => {
        //     this.PopularRecordsList = res;
        //     this.popularFlights = this.tab === 0 ? this.PopularRecordsList?.finalDom ?? [] : this.PopularRecordsList?.finalInt ?? [];
        // });
    }

    /**
     * Handles flight type option changes and updates form accordingly
     * @param v - The selected flight type value
     */
    optionChange(v: any): void {
        this.formGroup.get('type').setValue(v);
        if (v === 'mc') {

            const multicityLength = this.formGroup.get('multiCityObjects').value
            if (multicityLength.length < 1) {
                this.formGroup.get('multiCityObjects').patchValue(this.formDataList)
                this.formDataList[1].fromListData = this.formDataList[0].toListData;
            }

            const add = this.formDataList.length < 2;
            if (add)
                this.addCity(0);
        } else {
            this.formGroup.get('multiCityObjects').patchValue([]);
        }

        if (v === 'rt') {
            this.fetchReturnDateFares();
        }

        if (v === 'ab') {
            this.flightsService
            .getAirportMstCombo('', '', '',true)
            .subscribe({
                next: (res) => {
                    this.allCity = res;
                    this.fromCityList.next(res);
                    this.toCityList.next(res);
                    this.selectedFromCity = this.formGroup.value.fromCity.airport_code
                    this.selectedToCity = this.formGroup.value.toCity.airport_code
                    this.fetchDateWiseFares();

                    if (this.formDataList.length < 2) {
                        this.formDataList.forEach((x: MulticityDTO) => {
                            x.fromListData = res;
                            x.toListData = res;
                            x.allListData = res;
                        });
                        this.addCity(0);
                    }
                }, error: (err) => {
                    this.alertService.showToast('error', err);
                }
            });

            this.formGroup.get('fromCity').setValue('All Cities');
            this.formGroup.get('toCity').setValue('All Cities');
            this.formGroup.get('departureDate').setValue(null);
        } else {
            const currentFromCity = this.formGroup.get('fromCity').value;
            if (currentFromCity === 'All Cities') {
                let firstCity: any = null;
                this.fromCityList.subscribe(list => {
                    if (list && list.length > 0) {
                        firstCity = list[0];
                    }
                }).unsubscribe();
                this.formGroup.get('fromCity').setValue(firstCity);
            }
            const currentToCity = this.formGroup.get('toCity').value;
            if (currentToCity === 'All Cities') {
                let firstCity: any = null;
                this.toCityList.subscribe(list => {
                    if (list && list.length > 0) {
                        firstCity = list.length > 1 ? list[1] : list[0];
                    }
                }).unsubscribe();
                this.formGroup.get('toCity').setValue(firstCity);
            }
            const currentDdepartureDate = this.formGroup.get('departureDate').value;
            if (!currentDdepartureDate) {
                const date = new Date();
                this.formGroup.get('departureDate').setValue(date);
            }
        }
    }


    /**
     * Handles flight type selection change from UI
     * @param data - Object containing the selected flight type id
     */
    flightTypeChange(data: any) {
        this.formGroup.get('type').patchValue(data.id);
        this.optionChange(this.formGroup.get('type').value);
    }

    /**
     * Handles selection of a recent search item
     * @param val - The recent search object containing flight details
     */
    recentSearch(val: any): void {
        val.text = 'recentSearch';
        this.detail(val);
    }
    /**
     * Handles selection of a popular destination item
     * @param val - The popular destination object containing flight details
     */
    popular(val: any): void {
        val.text = 'popular';
        this.detail(val);
    }

    /**
     * Filters airport/city list based on search input for multi-city flights
     * @param value - The search string to filter by
     * @param formData - The multi-city form data object to update
     * @param name - The field name being filtered ('from' or 'to')
     */
    filterfrom(value: string, formData: MulticityDTO, name: any) {
        this.flightsService.getAirportMstCombo(value,'','',(this.formGroup.get('type').value=='ab'?true:false)).subscribe({
            next: (res) => {
                if (res) {
                    if (name === 'from') {
                        formData.fromListData = res;
                    } else if (name === 'to') {
                        formData.toListData = res;
                    }
                    formData.allListData = res;
                }
            },
        });
        const fromFilter = formData.allListData.filter((x) =>
            (
                x.display_name.toLowerCase() ||
                x.airport_name.toLowerCase() ||
                x.country.toLowerCase()
            ).includes(value.toLowerCase())
        );
        if (name === 'from') {
            formData.fromListData = fromFilter;
        } else if (name === 'to') {
            formData.toListData = fromFilter;
        }
    }

    /**
     * Opens the travellers and class selection dialog
     * Allows users to select number of passengers and cabin class
     */
    travellersClass(): void {
        this.isOpenTravellersClass = true;
        const json = { form: this.formGroup.value, fareTypeList: this.fareType };
        json.form.service = 'flight';
        this.matDialog
            .open(TravellersClassComponent, {
                data: json,
                panelClass: [CommonUtils.isMobile() || CommonUtils.isTablet() ? 'full-screen-model' : '']
            })
            .afterClosed()
            .subscribe({
                next: (res) => {
                    this.formGroup.patchValue(this.formGroup.value);
                    this.isOpenTravellersClass = false;
                    this.CheckFareTypeValidation();
                },
            });
    }

    /**
     * Validates fare type and child/infant count
     * Shows error message if child/infant are not allowed for special fare types
     */
    CheckFareTypeValidation() {
        let fareValid = this.formGroup.get('fareType').value !== 'Regular' && this.formGroup.get('fareType').value !== 'Armed Forces';
        if (fareValid) {
            let childInfant = this.formGroup.get('child').value > 0 || this.formGroup.get('infant').value > 0;
            if (childInfant) {
                this.alertService.showToast('error', 'Child and Infant are not allowed for this spacial fare.');
                this.formGroup.patchValue(
                    {
                        child: 0,
                        infant: 0,
                    }
                );
            }
        }
    }

    /**
     * Placeholder function for publishing block functionality
     */
    publishBlock(): void { }

    /**
     * Navigates to the group booking inquiry page
     */
    viewInquiry(): void {
        //this.router.navigate(['/agent/my-booking/group-booking'])
        this.router.navigate(['/agent/my-leads/group-booking']) // Ticket https://multiicon.atlassian.net/browse/BE-435
    }

    /**
     * Switches the from and to cities for regular or multi-city flights
     * @param i - Optional index for multi-city flights
     */
    switch(i?: any): void {
        if (this.formGroup.get('type').value === 'mc') {
            const form = this.formDataList[i].fromCity;
            const to = this.formDataList[i].toCity;
            const fromListData = this.formDataList[i].fromListData;
            const toListData = this.formDataList[i].toListData;
            this.formDataList[i].fromCity = to;
            this.formDataList[i].toCity = form;
            this.formDataList[i].fromListData = toListData;
            this.formDataList[i].toListData = fromListData;
            this.changeValue(this.formDataList[i].toCity, i);
        } else {
            const from = this.formGroup.get('fromCity').value;
            const to = this.formGroup.get('toCity').value;
            const fromCityList = this.fromCityList;
            const toCityList = this.toCityList;
            this.formGroup.get('fromCity').patchValue(to);
            this.formGroup.get('toCity').patchValue(from);
            this.fromCityList = toCityList;
            this.toCityList = fromCityList;

            this.selectedFromCity = to.airport_code
            this.selectedToCity = from.airport_code
            if (this.formGroup.get('type').value === 'ow') {
                this.fetchDateWiseFares()
            }
            else {
                this.fetchReturnDateFares();
            }
        }
    }

    /**
     * Updates the next segment's from city in multi-city flights
     * @param v - The selected city value
     * @param i - The current segment index
     * @param name - Optional parameter name
     */
    changeValue(v: any, i: any, name?: any): void {
        if (name) {
            if (this.formDataList[i + 1]) {
                this.formDataList[i + 1].fromCity = v;
                this.formDataList[i + 1].filterfrom = v.airport_name;
                this.filterfrom(
                    v.airport_name,
                    this.formDataList[i + 1],
                    'from'
                );
            }
        }
        if (!name) {
            if (this.formDataList[i + 1]) {
                this.formDataList[i + 1].fromCity = v;
                this.formDataList[i + 1].filterfrom = v.display_name;
                this.filterfrom(v.airport_name, this.formDataList[i + 1], 'from');
            }
        }
    }

    /**
     * Validates form data and navigates to flight details page
     * @param val - Optional value from recent or popular searches
     */
    detail(val?: any): void {
        const fromCity = this.formGroup.get('fromCity')?.value;
        const toCity = this.formGroup.get('toCity')?.value;
        const type = this.formGroup.get('type')?.value;

        // Check if both are "All Cities"
        const bothAllCities = type === 'ab' && fromCity === 'All Cities' && toCity === 'All Cities';

        // Trigger error if IDs are same, and not the "both all cities" case
        if (!bothAllCities && fromCity?.id && toCity?.id && fromCity.id === toCity.id) {
            this.alertService.showToast(
                'error',
                'Both destinations are same, please choose both destinations are different'
            );
        }
        else {
            const json = this.formGroup.getRawValue();
            if (this.formGroup.get('type').value === 'mc') {
                const hasError = json.multiCityObjects.length < 1
                const hasEmptyFields = json.multiCityObjects.some(
                    (x) =>
                        !x.fromCity ||
                        !x.toCity ||
                        x.departureDate === 'Invalid DateTime'
                );

                if (hasEmptyFields || hasError) {
                    this.alertService.showToast(
                        'error',
                        'Please fill all the fields.'
                    );
                    return;
                }
            }
            json.fromCity = json.fromCity.id;
            json.toCity = json.toCity.id;
            json.departureDate = DateTime.fromJSDate(
                new Date(json.departureDate)
            ).toFormat('yyyy-MM-dd');
            json.returnDate = json.returnDate
                ? DateTime.fromJSDate(new Date(json.returnDate)).toFormat('yyyy-MM-dd')
                : null;
            if (json.multiCityObjects) {
                json.multiCityObjects.forEach((x) => {
                    x.departureDate = DateTime.fromJSDate(
                        new Date(x.departureDate)
                    ).toFormat('yyyy-MM-dd');
                });
            }

            let sourceCity: string;
            let destinationCity: string;

            if (this.formGroup.get('type')?.value === 'ab') {
                sourceCity = this.formGroup.get('fromCity')?.value === 'All Cities'
                    ? 'all-cities'
                    : this.formGroup.get('fromCity')?.value?.city_code;

                destinationCity = this.formGroup.get('toCity')?.value === 'All Cities'
                    ? 'all-cities'
                    : this.formGroup.get('toCity')?.value?.city_code;
            } else {
                sourceCity = this.formGroup.get('fromCity')?.value?.city_code;
                destinationCity = this.formGroup.get('toCity')?.value?.city_code;
            }
            if (val?.text === 'recentSearch') {
                json.fromCity = val.origin_id;
                json.toCity = val.destination_id;
                json.departureDate = DateTime.fromJSDate(
                    new Date(val.depDate)
                ).toFormat('yyyy-MM-dd');

                sourceCity = val.origin;
                destinationCity = val.destination;

            } else if (val?.text === 'popular') {
                json.fromCity = val.origin_id;
                json.toCity = val.destination_id;
                json.departureDate = json.departure_date_time || json.departureDate;

                sourceCity = val.origin;
                destinationCity = val.destination;
            }
            this.cacheService.MainFilterChanged(json, 'flight-filters');
            let navigationURL: any;
            if (this.formGroup.get('type')?.value === 'ab') {
                navigationURL = '/flights/' + sourceCity + '-' + destinationCity;
                if (this.formGroup.get('departureDate').value !== null) {
                    navigationURL = navigationURL + '/' + json.departureDate;
                } else {
                    navigationURL = navigationURL + '/all-dates';
                }
            } else {
                navigationURL = '/flights/' + sourceCity + '-' + destinationCity + '/' + json.departureDate;
                if (json.type == 'rt' || json.type == 'gi') {
                    if (json.returnDate) {
                        navigationURL = navigationURL + '/' + json.returnDate;
                    }
                }
            }
            navigationURL += '/A-' + json.adult + '/C-' + json.child + '/I-' + json.infant
                + '/' + (json.cabinClass || 'Economy').toLowerCase()
                + '/' + (json.fareType || 'Regular').toLowerCase();
            this.router.navigate([navigationURL]);
        }
    }

    /**
     * Updates subsequent segment dates in multi-city flights to maintain chronological order
     * @param v - The new date value
     * @param i - The current segment index
     */
    changeDate(v: any, i: any) {
        const changedDate = DateTime.fromJSDate(new Date(v)).toFormat(
            'yyyy-MM-dd'
        );

        if (
            this.formDataList[i + 1] &&
            this.formDataList[i + 1].departureDate
        ) {
            const AfterDate = DateTime.fromJSDate(
                new Date(this.formDataList[i + 1].departureDate)
            ).toFormat('yyyy-MM-dd');
            if (AfterDate < changedDate) {
                this.formDataList[i + 1].departureDate = changedDate;
            }
        }
        if (this.formDataList[i + 1] && !this.formDataList[i + 1].departureDate)
            this.formDataList[i + 1].departureDate = changedDate;
    }

    /**
     * Adds a new city segment to multi-city flights
     * @param i - Optional index of the current segment
     */
    addCity(i?: any) {
        if (i > 0) {
            if (
                !this.formDataList[i].fromCity ||
                !this.formDataList[i].toCity ||
                !this.formDataList[i].departureDate
            ) {
                this.alertService.showToast(
                    'error',
                    'Please fill all the fields.'
                );
                return;
            }
        }
        var obj = new MulticityDTO();
        obj.fromListData = this.allCity;
        obj.toListData = this.allCity;
        obj.allListData = this.allCity;
        this.formDataList.push(obj);
        if (i === 0) {
            this.formDataList[0].fromCity = this.allCity[0];
            this.formDataList[0].toCity = this.allCity[1];
            this.formDataList[1].fromCity = this.formDataList[0].toCity;
            this.formDataList[0].departureDate = new Date();
            this.formGroup.get('multiCityObjects').patchValue(this.formDataList);
        }
        if (i) this.changeValue(this.formDataList[i]?.toCity, i);
        this.changeDate(this.formDataList[i]?.departureDate, i);
    }

    /**
     * Removes the last city segment from multi-city flights
     */
    removeCity() {
        if (this.formDataList.length > 1) {
            this.formDataList.pop();
        }
    }

    /**
     * Comparison function for select options to track selections by ID
     * @param v1 - First value to compare
     * @param v2 - Second value to compare
     * @returns Boolean indicating if the values are equal by ID
     */
    public compareWith(v1: any, v2: any) {
        return v1 && v2 && v1.id === v2.id;
    }

    /**
     * Redirects to the publish block page
     */
    publishYourBlock() {
        Linq.recirect('/publish-your-block');
    }

    // Open From City Dropdown
    /**
     * Programmatically opens the from city dropdown
     */
    openFromCityDropdown() {
        this.fromCitySelect.open();
    }

    // Open To City Dropdown
    /**
     * Programmatically opens the to city dropdown
     */
    openToCityDropdown() {
        this.toCitySelect.open();
    }

    // Open the From City dropdown programmatically based on index
    /**
     * Opens the from city dropdown for a specific multi-city segment
     * @param index - The index of the multi-city segment
     */
    openFromMultiCityDropdown(index: number) {
        const fromSelect = this.fromMultiCitySelect.toArray()[index];
        if (fromSelect) {
            fromSelect.open();
        }
    }

    // Open the To City dropdown programmatically based on index
    /**
     * Opens the to city dropdown for a specific multi-city segment
     * @param index - The index of the multi-city segment
     */
    openToMultiCityDropdown(index: number) {
        const toSelect = this.toMultiCitySelect.toArray()[index];
        if (toSelect) {
            toSelect.open();
        }
    }

    helpVideo(sectionName) {
        this.videoHelpService.helpVideo(sectionName);
    }

    /**
     * Angular lifecycle hook that cleans up subscriptions when the component is destroyed
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}

class MulticityDTO {
    fromCity: any;
    toCity: any;
    departureDate: string = '';
    fromListData: any[] = [];
    fromfilter: string = '';
    toListData: any[] = [];
    tofilter: string = '';
    allListData: any[];
}
